import { IMAGES, DEVELOPMENT_ITEMS } from '../mock';

export default function Development() {
  return (
    <section id="development" className="bg-[#f1ede5] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <img
              src={IMAGES.brick}
              alt="Heritage brickwork"
              className="w-full h-[520px] object-cover"
            />
            <div className="absolute -bottom-6 -left-6 w-24 h-24 border border-[#b39352] hidden md:block" />
          </div>

          <div>
            <span className="eyebrow">The Development</span>
            <h2 className="font-serif-display text-[42px] md:text-[54px] leading-[1.05] mt-6">
              A landmark mill,<br />
              <em className="text-[#b39352] italic">reimagined.</em>
            </h2>
            <p className="mt-6 text-[14px] leading-[1.85] text-[#0d281e]/80 max-w-xl">
              Valley Mills is undergoing a comprehensive refurbishment that combines the character of a
              historic Yorkshire mill with modern commercial accommodation. Every unit maximises natural
              light, flexibility and functionality — whilst retaining the building&apos;s original industrial soul.
            </p>

            <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-x-8">
              {DEVELOPMENT_ITEMS.map((item, i) => (
                <div key={item} className="num-list-item">
                  <span className="num">{String(i + 1).padStart(2, '0')}</span>
                  <span className="text-[14px] text-[#0d281e]">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
